import React from "react";
import styled from "styled-components";
import { TextProps } from "@xsolla/xui-primitives-core";
import { createFilteredElement } from "./filterDOMProps";
import { truncationStyles } from "./textTruncation";

const FilteredSpan = createFilteredElement("span");

const StyledText = styled(FilteredSpan)<TextProps>`
  color: ${(props) => props.color || "inherit"};
  font-size: ${(props) =>
    typeof props.fontSize === "number"
      ? `${props.fontSize}px`
      : props.fontSize || "inherit"};
  font-weight: ${(props) => props.fontWeight || "normal"};
  font-family: ${(props) =>
    props.fontFamily ||
    '"Aktiv Grotesk", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif'};
  line-height: ${(props) =>
    typeof props.lineHeight === "number"
      ? `${props.lineHeight}px`
      : props.lineHeight || "inherit"};
  white-space: ${(props) => props.whiteSpace || "normal"};
  text-align: ${(props) => props.textAlign || "inherit"};
  text-decoration: ${(props) => props.textDecoration || "none"};

  /* Keep last: single-line truncation has to win over white-space above. */
  ${(props) => truncationStyles(props.numberOfLines)}
`;

export const Text: React.FC<TextProps> = ({
  style,
  className,
  id,
  role,
  testID,
  "data-testid": dataTestId,
  ...props
}) => {
  return (
    <StyledText
      {...props}
      style={style}
      className={className}
      id={id}
      role={role}
      data-testid={dataTestId || testID}
    />
  );
};
